export default __webpack_public_path__ + "static/veganlogo-bd657e406620b9658bc60a146bbc602b.png";